import Box from '@totallymoney/ui/components/Box'
import Row from '@totallymoney/ui/components/Row'
import theme from '@totallymoney/ui/theme'

import StarSvg from './StarSvg'

interface StarRatingProps {
    color?: string
    emptyColor?: string
    rating: number
    size?: number
}

const StarRating = ({
    rating,
    size = 20,
    color = theme.indigo60,
    emptyColor = theme.grey30,
}: StarRatingProps) => {
    const stars = []
    const fullStars = Math.floor(rating)

    for (let i = 0; i < fullStars; i++) {
        stars.push(
            <StarSvg
                key={`full-${i}`}
                size={size}
                starColor={color}
                data-testid="full-star"
            />
        )
    }

    const emptyStars = 5 - stars.length
    for (let i = 0; i < emptyStars; i++) {
        stars.push(
            <StarSvg
                key={`empty-${i}`}
                size={size}
                starColor={emptyColor}
                data-testid="empty-star"
            />
        )
    }

    return (
        <Box display="flex" alignItems="center">
            <Row space="space10">{stars}</Row>
        </Box>
    )
}

export default StarRating
